import type { Configuration, IRequest } from '@cobliteam/api-lib';
import HttpMethod from '@cobliteam/api-lib/src/request/HttpMethod';
import Requester from '@cobliteam/api-lib/src/request/Requester';
import type { IRequest as BlueprintRequest, IRequester } from '@cobliteam/blueprint-react-renderer';
import type { AxiosResponse } from 'axios';

class BlueprintRequester implements IRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  request = (requestData: BlueprintRequest): Promise<AxiosResponse> => {
    return this.requester.request(mapRequest(requestData)) as Promise<AxiosResponse>;
  };

  requestWithSignal = (requestData: BlueprintRequest, signal: AbortSignal): Promise<AxiosResponse> => {
    return this.requester.requestWithSignal(mapRequest(requestData), signal) as Promise<AxiosResponse>;
  };

  getAbortController = () => {
    return this.requester.getAbortController();
  };
}

const methodMap: Record<string, HttpMethod> = {
  get: HttpMethod.GET,
  GET: HttpMethod.GET,
  post: HttpMethod.POST,
  POST: HttpMethod.POST,
  put: HttpMethod.PUT,
  PUT: HttpMethod.PUT,
  patch: HttpMethod.PATCH,
  PATCH: HttpMethod.PATCH,
  delete: HttpMethod.DELETE,
  DELETE: HttpMethod.DELETE,
};

function mapRequest(request: BlueprintRequest): IRequest {
  return {
    endpoint: request.endpoint,
    method: methodMap[request.method] ?? HttpMethod.GET,
    headers: request.headers,
    body: request.body,
    params: request.params as Record<string, string | number | undefined | null> | undefined,
    responseType: request.responseType,
    withCredentials: true,
  };
}

export default BlueprintRequester;
